<template>
    <div class="card">
        <div class="container-fluid">
            <div style="padding: 10px">
                <button type="button" @click="getUserModal" class="btn btn-primary contct-b pull-left"><i class="fa fa-life-bouy"></i> হোল্ডিং তৈরি করুন</button>
                <form class="form-inline contct my-2 my-lg-0 pull-right">
                    <input v-model="ward_search" class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
                    <button class="btn btn-outline-success my-2 my-sm-0" >Search</button>
                </form>
            </div>

<!--            <form class="form-inline contct my-2 my-lg-0 pull-right">-->
<!--                <select  @change="customerVisa(search.customer_id)" name="Customer" v-model="search.customer_id"  class="form-control" >-->
<!--                    <option value="" >Select Client</option>-->
<!--                    <option   :value="contact.id"  v-for="(contact,index) in allContacts" :key="index">{{contact.name}}</option>-->
<!--                </select>-->
                <!-- <select name="CustomerVisa" v-model="search.visa_id"  class="form-control" >
                    <option value="" >Select Visa</option>
                    <option   :value="customervisa.id"  v-for="(customervisa,index) in customervisas" :key="index">{{customervisa.worker_number}}</option>
                </select> -->
                <!-- <select v-model="search.purpose"  class="form-control" style="margin-right:10px">
                    <option value="" >Select Account Type</option>
                    <option v-if="index == 0" disabled style="font-weight:800" v-for="(accountType,index) in getAccountType" :key="index+1000">{{accountType.name.toUpperCase()}}</option>
                    <option v-if="purpose.account_type_id == 15"  v-for="(purpose,index) in purposes" :key="index+2000" :value="purpose.id">{{purpose.name}}</option>
                    <option v-if="index == 1" disabled style="font-weight:800"  v-for="(accountType,index) in getAccountType" :key="index+3000">{{accountType.name.toUpperCase()}}</option>
                    <option v-if="purpose.account_type_id == 16"  v-for="(purpose,index) in purposes" :key="index+4000" :value="purpose.id">{{purpose.name}}</option>
                </select> -->
<!--                <button @click.prevent="searchIncome" class="btn btn-outline-success my-2 my-sm-0" >Search</button>-->
<!--            </form>-->
            <table class="table table-sm mt-5">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">বাংলায় নাম</th>
                    <th scope="col">ইংরেজিতে নাম</th>
                    <th scope="col">বাসার নাম </th>
                    <th scope="col">অ্যাড্রেস</th>
                    <th scope="col">ওয়ার্ড</th>
                    <th scope="col">স্ট্যাটাস</th>
                    <th scope="col">Actions</th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="(holding,index) in holdings.data" :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{holding.bn_name}}</td>
                    <td>{{holding.en_name}}</td>
                    <td>{{holding.home_name}}</td>
                    <td>{{holding.address}}</td>
                    <td>{{holding.word_no}}</td>
                    <td>{{holding.status==1?'Approved':'Pending'}}</td>
                    <td>
                        <i @click="editHoldingModal(holding,index)" class="icon-note icons actn"> </i>
                        <i @click="viewHoldingModal(holding)" class="icon-eye icons   actn"> </i>
                        <i @click="deleteHoldingModal(index,holding.id)" class="icon-trash icons   actn"> </i>
                    </td>
                </tr>
                </tbody>
            </table>
            <nav v-if="loading==false" aria-label="Page navigation example">
                <pagination :data="holdings" @pagination-change-page="holdingLists" :limit="8"></pagination>
            </nav>
        </div>
        <addHoldingModal ref="add_holding_modal"></addHoldingModal>
        <EditHoldingModal ref="edit_holding_modal"></EditHoldingModal>
        <viewHoldingModal ref="view_holding_modal" :type="is_type_form.is_type"></viewHoldingModal>
        <FindUser @userInfo="userInfo" ref="find_user"></FindUser>
        <Loader v-if="loading"></Loader>
    </div>
</template>
<script>
    import pagination from 'laravel-vue-pagination'
    import Loader from '../common/Loader'
    import axios from 'axios'
    import  addHoldingModal from './addHoldingModal'
    import  EditHoldingModal from './editHoldingModal'
    import viewHoldingModal from './viewHoldingModal'
    import FindUser from '../application/others/find_user_for_holding'
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import { mapState,mapGetters } from "vuex"
    import { VueEditor } from 'vue2-editor'
    export  default {
        name : 'Holding' ,
        data(){
            return{
                loading:false,
                ward_search:'',
                is_type_form:{
                    is_type:''
                }
            }
        },
        computed:{
           ...mapGetters(['holdings']),
          filter_holdiyng(){
              if(!this.ward_search){
                  return this.holdings
              }else {
                 return  this.holdings.filter( v => v.word_no == this.ward_search)
              }
          },
        },
        mounted(){
             this.holdingLists()
        },
        watch:{
            $route (){
                // this.show = false;
                this.holdingLists()
            }
        },
        methods:{
            getUserModal(){
                if(this.$user.type == 2){
                    var user = {
                        nid:this.$user.nid,
                        mobile_number:this.$user.mobile_number,
                    }
                    axios.post("/api/application-user/check",user).then(response=>{
                        this.userInfo(response.data)
                    })
                }else{
                    this.$refs.find_user.openModal()
                }
            },
            userInfo(data){
                this.$refs.add_holding_modal.openModal(data)
             },
            holdingLists(page=1){
                var type = this.$route.path
                var arr = type.split('/')
                this.is_type_form.is_type =arr[2]
                var data_1 = this.is_type_form
                var data = {data_1:data_1,page:page}
                this.$store.dispatch('HOLDING_LIST',data)
            },
            editHoldingModal(holding,index){
                this.$refs.edit_holding_modal.openModal(holding,index)
            },
            deleteHoldingModal(index,id){
                //console.log(id)
                this.$store.dispatch('DELETE_HOLDING',{id,index})
            },

            viewHoldingModal(holding){
                this.$refs.view_holding_modal.openModal(holding)
            }
            // searchWard(){
            //     if(this.ward_search!=null){
            //         this.$store.getters('holdings').filter(holding=>{
            //             return holding.word_no==this.ward_search
            //         })
            //     }
            // }
        },
        components: {
            addHoldingModal,
            EditHoldingModal,
            viewHoldingModal,
            FindUser,
            pagination,
            Loader
        }

    }
</script>
<style scoped>
    .actn{
        margin-left: 10px;
        cursor: pointer;
    }
</style>